(function ($, Promise) {

        // Setup the prototype inheritance
        extend(BaseGamePAC, PACLexique);

        // Constructor
        function PACLexique() {

            this.defaultEasing = CustomEase.create("custom", "M0,0 C0,0 0.108,0.051 0.152,0.114 0.263,0.272 0.424,1 0.96,1 0.984,1 1,1 1,1");

            this.impetusGrid = false;
            this.impetusGridLastPosition = {x: 0, y: 9};

            this.titleTimeline = false;
            this.currentTitleMode = "big";

            this.$gridContent = false;

            this.currentLanguage = false;
            this.currentCategoryIndex = -1;
            this.playWordTimeline = false;
            this.isAnimatingDrag = false;
            this.stickyTopAdditionalMargin = false;

            // Super constructor
            BaseGamePAC.call(this, "data/lexique.json");
        };

        // To be overriden in child games
        PACLexique.prototype.buildDOM = function () {
            return new Promise($.proxy(function (resolve, reject) {

                this.$gridContent = $("#grid .inner");
                this.stickyTopAdditionalMargin = $("#grid").offset().top;
                this.screensaver = new PACLexiqueScreenSaver(this.data);

                gsap.config({
                    force3D: false,
                });

                // Create slider - Resize titles according to word length
                $(".fr, .en", "#main-slider .swiper-slide .content-wrapper > .title").each($.proxy(function (k, titleItem) {
                    $(titleItem).attr("style", "display: inline-block !important;");
                    requestAnimationFrame(function () {
                        if ($(titleItem).height() > 60) {
                            $(titleItem).addClass("small")
                            requestAnimationFrame(function () {
                                if ($(titleItem).height() > 50) {
                                    $(titleItem).addClass("smaller")
                                }
                                $(titleItem).attr("style", "");
                            })
                        } else {
                            $(titleItem).attr("style", "");
                        }
                    });
                }, this));


                // Create slider - Resize translation items according to word length
                $("#main-slider .swiper-slide .translation-item.trigger .language-word").each($.proxy(function (k, languageWord) {
                    requestAnimationFrame(function () {
                        if ($(languageWord).height() > 60 || widestPart(languageWord) > $(languageWord).width()) {
                            $(languageWord).addClass("small")
                            requestAnimationFrame(function () {
                                if ($(languageWord).height() > 50 || widestPart(languageWord) > $(languageWord).width()) {
                                    $(languageWord).addClass("smaller")
                                }
                            })
                        }
                    });
                }, this));

                // Create slider - Create special markup for language words
                $("#main-slider .swiper-slide .translation-item.trigger .language-word").each($.proxy(function (k, translationItem) {
                    var newMarkup = this.createSplittedWordsMarkup($(translationItem).html());
                    $(translationItem).html(newMarkup)
                }, this));

                $(".grid-item").on("click", $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    this.selectItemFromGrid($el, $el.data("category-index"), $el.data("item-index"));
                }, this));

                // $(".grid-item").on(this.touchEvent, $.proxy(function (e) {
                // e.stopImmediatePropagation();
                // var $el = $(e.currentTarget);
                // this.selectItem($el.data("category-index"), $el.data("item-index"));
                // }, this));

                $(".language-item").on(this.touchEvent, $.proxy(function (e) {
                    var languageCode = $(e.currentTarget).data("language");
                    this.selectLanguageBarItem(languageCode)
                }, this));

                this.mainSwiper = new Swiper('#main-slider', {
                    speed: 700,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on: {
                        slideChange: $.proxy(this.onItemSelect, this)
                    },
                    threshold: 5,
                    // effect: "fade",
                    // fadeEffect: {
                    //     crossFade: true
                    // },
                });
                this.onItemSelect();

                // Impetueus plugin used for main timeline
                this.impetusGrid = new Impetus({
                    source: "#grid",
                    boundX: [0, 1],
                    boundY: [0, 1],
                    update: $.proxy(this.updateImpetusGridPosition, this)
                });
                this.impetusGrid.pause();

                // Handle svg
                var targetWidth = 136.369
                var targetHeight = 128.858
                var targetRatio = targetWidth / targetHeight;
                window.convertSVGToInline(function (img) {
                    if ($(img).parent().hasClass("main-image") || $(img).parent().hasClass("image-wrapper")) {
                        if ($(img).attr("viewBox")) {
                            var viewBox = $(img).attr("viewBox").split(" ");
                            var ratio = viewBox[2] / viewBox[3];
                            if (ratio > targetRatio) {
                                $(img).attr("width", targetWidth);
                                $(img).attr("height", targetWidth / ratio);
                            } else {
                                $(img).attr("height", targetHeight);
                                $(img).attr("width", targetHeight * ratio);
                            }
                        } else {
                            console.warn("Couldn't extract viewBox for image.", img)
                        }
                    }
                });

                // $(".main-image svg").each(function (i, n) {
                //     console.log(n)
                // });

                $("#main").addClass("ready");

                resolve();

            }, this));
        }

        // To be overriden in child games
        PACLexique.prototype.initGame = function () {
            console.log("init game");

            // Go to first screen
            this.initScreenSaver();
            this.selectLanguageBarItem("algonquin");
            this.goToScreen(1);

            // this.goToScreen(2);
            // this.goToScreen(3);
        };

        // To be overriden in child games
        PACLexique.prototype.initScreen = function (screenId) {

            // Super constructor
            if (BaseGamePAC.prototype.initScreen.call(this, screenId) == false) {
                return false;
            }

            switch (screenId) {
                case 1:
                    this.placeTitle("big");
                    this.enableImpetusGrid(false);
                    this.toggleLanguageButton(false);
                    this.screensaver.start();
                    break;
                case 2:
                    this.placeTitle("small");
                    this.enableImpetusGrid(true);
                    this.toggleLanguageButton(true);
                    this.screensaver.stop();
                    break;
                case 3:
                    this.placeTitle("small");
                    this.screensaver.stop();
                    break;
            }

        }

        PACLexique.prototype.start = function (language) {

            // Super constructor
            if (BaseGamePAC.prototype.start.call(this) == false) {
                return;
            }

            console.log("starting in ", language)
        }

        PACLexique.prototype.selectIntroLanguage = function (e) {

            var language = $(e.currentTarget).data("lang");
            this.i18n.setWithFlip(language);

            if (this.interval != false) {
                clearInterval(this.interval);
                this.interval = false;
            }
            this.interval = setTimeout($.proxy(function () {
                this.goToScreen(2);
            }, this), 100)


            this.placeTitle("small");
        }

        PACLexique.prototype.placeTitle = function (titleMode) {

            if (titleMode == this.currentTitleMode) {
                return;
            }

            if (this.titleTimeline) {
                this.titleTimeline.kill();
                this.titleTimeline = false;
            }

            this.titleTimeline = new TimelineMax();

            if (titleMode == "small") {
                this.titleTimeline.to($("#game-title"), 0.95, {
                    x: -50,
                    y: -50,
                    scale: 0.65,
                    transformOrigin: "left top",
                    ease: this.defaultEasing,
                });
                this.titleTimeline.to($("#game-title .subtitle"), 0.45, {
                    y: -20,
                    autoAlpha: 0,
                    ease: this.defaultEasing,
                }, 0);


            } else if (titleMode == "big") {
                this.titleTimeline.to($("#game-title"), 0.95, {
                    y: 0,
                    scale: 1,
                    transformOrigin: "left top",
                    ease: this.defaultEasing,
                });
                this.titleTimeline.to($("#game-title .subtitle"), 0.45, {
                    y: 0,
                    autoAlpha: 1,
                    ease: this.defaultEasing,
                }, 0);
            }

            this.currentTitleMode = titleMode;
        }

        PACLexique.prototype.updateImpetusGridPosition = function (x, y) {

            if (this.impetusGrid.paused == false) {

                // Set position using TweenMax instead of direct CSS
                // to avoid conflict with sidebar
                // this.$gridContent.css("transform", "translate3D(0, " + y + "px, 0)")
                TweenMax.set(this.$gridContent, {
                    y: y
                });

                this.impetusGridLastPosition.x = x;
                this.impetusGridLastPosition.y = y;

                var currentTitle = false;
                var currentOffsetY = false;
                var currentTitleIndex = false;
                var nextTitle = false;
                var nextOffsetY = 0;
                var stickyTopAdditionalMargin = this.stickyTopAdditionalMargin;

                $("#grid .grid-category").each($.proxy(function (i, n) {
                    if ($(n).offset().top <= stickyTopAdditionalMargin) {
                        currentOffsetY = $(n).offset().top
                        currentTitleIndex = $(n).data("category-index");
                        currentTitle = n;
                    } else if ($(n).offset().top > stickyTopAdditionalMargin) {
                        nextOffsetY = $(n).offset().top
                        nextTitle = n;
                        return false;
                    }
                }));

                // Update position
                var stickyCategoryPosition = Math.min(stickyTopAdditionalMargin, nextOffsetY - ($(nextTitle).outerHeight() || 0));
                if (currentTitleIndex === false) {
                    $("#grid-sticky-category").hide();
                } else {
                    $("#grid-sticky-category").show().css("top", stickyCategoryPosition);
                    this.updateCategory(currentTitleIndex)
                }

                // Update state class value
                if (stickyCategoryPosition == stickyTopAdditionalMargin) {
                    // console.log("sticky")
                    $("#grid-sticky-category").addClass("is-sticky");
                } else {
                    // console.log("not sticky")
                    $("#grid-sticky-category").removeClass("is-sticky");
                }

            }
        }

        PACLexique.prototype.enableImpetusGrid = function (toggleValue) {

            if (toggleValue == true) {
                // Enable Impetus scrolling

                if (this.$gridContent.height() > $("#sidebar").height()) {
                    this.impetusGrid.paused = false;
                    this.impetusGrid.setBoundY([-(this.$gridContent.outerHeight() - $("#grid").height()), 0]);
                    this.updateImpetusGridPosition(0, this.impetusGridLastPosition);
                    this.impetusGrid.setMultiplier(1);
                    this.impetusGrid.resume();
                }

            } else {
                // Disable Impetus scrolling
                this.impetusGrid.paused = true;
                this.impetusGrid.setMultiplier(0);
                this.impetusGrid.setValues(0, 0);
                this.impetusGrid.pause();
            }
        }

        PACLexique.prototype.updateCategory = function (categoryIndex) {

            if (this.currentCategoryIndex == categoryIndex) {
                return
            }

            // Update fixed category title
            $("#grid-sticky-category").html($("#grid .grid-category[data-category-index='" + categoryIndex + "']").html());

            // Update category
            this.currentCategoryIndex = categoryIndex;

            // Update sidebar
            if (!this.isAnimatingDrag) {
                this.updateSelectedCategoryItem(categoryIndex);
            }
        }

        PACLexique.prototype.updateSelectedCategoryItem = function (categoryIndex) {
            $("#sidebar .category").removeClass("active").eq(categoryIndex).addClass("active");
            var dotY = $("#sidebar .category.active").offset().top - $("#sidebar").offset().top;
            $("#sidebar .dot").css("transform", "translate3D(0, " + dotY + "px, 0)");
        }

        PACLexique.prototype.updateSelectedCategoryItemInSlider = function (categoryIndex) {
            var itemData = this.data.categories[categoryIndex];
            $("#category-clone .fr").text(itemData.title.fr);
            $("#category-clone .en").text(itemData.title.en);
        }

        PACLexique.prototype.selectCategory = function (categoryIndex) {

            if (this.currentCategoryIndex == categoryIndex || this.isAnimatingDrag) {
                return
            }

            this.updateSelectedCategoryItem(categoryIndex);

            // Animate in
            this.isAnimatingDrag = true;
            var tl = new TimelineMax();
            var wrapperOffset = $("#grid").offset().top;
            var targetPosition = $("#grid .grid-category").eq(categoryIndex).offset().top - $("#grid .inner").offset().top;
            tl.to(this.$gridContent, 1.05, {
                y: -targetPosition,
                ease: this.defaultEasing,
                onUpdate: function () {
                    var offsetTop = this.$gridContent.offset().top - wrapperOffset;
                    this.impetusGrid.setValues(0, offsetTop);
                    this.updateImpetusGridPosition(0, offsetTop)
                },
                onComplete: function () {
                    this.isAnimatingDrag = false;
                },
                onUpdateParams: [],
                callbackScope: this,
                immediateRender: false,
            });

        }

        PACLexique.prototype.selectItemFromGrid = function ($el, categoryIndex, itemIndex) {
            console.log("selectItem", categoryIndex, itemIndex);

            var slideIndex = $el.data("simple-index");
            var itemData = this.data.categories[categoryIndex].items[itemIndex];

            // Create transition clone
            $("#item-clone").remove()
            var clone = $el.find(".main-image").clone();
            clone.attr("id", "item-clone")
            clone.css({
                top: "",
                left: "",
                position: "absolute",
                zIndex: 10,
                overflow: "hidden",
            });
            clone.find(".title").remove();
            $("#main").append(clone)

            // Language bar
            // this.updateLanguageBar(categoryIndex, itemIndex);

            // Hide current screen
            this.goToScreen();

            // Set active slide
            this.mainSwiper.slideTo(slideIndex, 0);

            // Update category clone
            TweenMax.set("#category-clone", {
                autoAlpha: 1,
            });

            // Reset slider animated properties
            TweenMax.set($("#main-slider, #language-bar"), {
                opacity: 1,
                scale: 1.0,
            }, 0);

            // Animate in
            var tl = new TimelineMax();
            var targetPositionElement = $("#main-slider .swiper-slide .image-wrapper").eq(slideIndex);
            tl.fromTo(clone, 1.05, {
                x: $el.find(".main-image svg").offset().left,
                y: $el.find(".main-image svg").offset().top,
                width: $el.find(".main-image svg").width(false),
                height: $el.find(".main-image svg").height(false),
            }, {
                x: targetPositionElement.offset().left,
                y: targetPositionElement.offset().top,
                scale: 2.3,
                transformOrigin: "left top",
                ease: this.defaultEasing,
            });

            tl.add($.proxy(function () {
                this.goToScreen(3);
            }, this), "+=0", [], this);
            tl.add($.proxy(function () {
                requestAnimationFrame(function () {
                    clone.remove()
                    $el.find(".main-image").css("visibility", "");
                });
                // this.playWord();
            }, this), "+=0.35", [], this);

            requestAnimationFrame(function () {
                $el.find(".main-image").css("visibility", "hidden");
            });

        }

        PACLexique.prototype.onItemSelect = function () {
            var activeSlideIndex = this.mainSwiper.activeIndex;
            var categoryIndex = $("#main-slider .swiper-slide").eq(activeSlideIndex).data("category-index");
            var itemIndex = $("#main-slider .swiper-slide").eq(activeSlideIndex).data("item-index");
            var itemData = this.data.categories[categoryIndex].items[itemIndex];

            // Stop current playing
            this.stopWord();

            // var tl = new TimelineMax();
            // tl.to($("#language-bar"), 0.45, {
            //     y: 10,
            //     opacity: 0,
            //     ease: this.defaultEasing,
            // });
            // tl.add($.proxy(function (categoryIndex, itemIndex) {
            //     this.updateLanguageBar(categoryIndex, itemIndex);
            // }, this, categoryIndex, itemIndex), "+=0", [], this);
            // tl.to($("#language-bar"), 0.45, {
            //     y: 0,
            //     opacity: 1,
            //     ease: this.defaultEasing,
            // });

            this.updateSelectedCategoryItemInSlider(categoryIndex);
        }

        // PACLexique.prototype.updateLanguageBar = function (categoryIndex, itemIndex) {
        // console.log("updateLanguageBar");
        // var itemData = this.data.categories[categoryIndex].items[itemIndex];
        // $("#language-bar").find(".algonquin .word-in-language").html(itemData.translations_items.algonquin[0].text);
        // $("#language-bar").find(".mohawk .word-in-language").html(itemData.translations_items.mohawk[0].text);
        // $("#language-bar").find(".wendat .word-in-language").html(itemData.translations_items.wendat[0].text);
        // }

        PACLexique.prototype.selectLanguageBarItem = function (languageCode) {
            if ($("#main-slider .language-word." + languageCode).hasClass("current") || (this.currentLanguage == languageCode)) {
                return;
            }

            this.currentLanguage = languageCode;

            $("#language-bar .language-item").removeClass("active");
            $("#language-bar .language-item[data-language=" + languageCode + "]").addClass("active");

            var tl = new TimelineMax();
            tl.to($(".swiper-slide-active .translations-items"), 0.35, {
                y: 10,
                opacity: 0,
                ease: this.defaultEasing,
            });

            tl.add($.proxy(function (languageCode) {
                $("#main-slider .indigenous").removeClass("current");
                $("#main-slider .indigenous." + languageCode).addClass("current");
                this.stopWord();
            }, this, languageCode), "+=0", [], this);

            tl.to($(".swiper-slide-active .translations-items"), 0.35, {
                y: 0,
                opacity: 1,
                ease: this.defaultEasing,
            });
        }

        PACLexique.prototype.createSplittedWordsMarkup = function (fullWord) {
            var markup = "";
            var splittedWord = fullWord.split(" ");

            for (var i = 0; i < splittedWord.length; i++) {
                markup += '<div class="part"><div class="background">' + splittedWord[i] + '&nbsp;</div><div class="progress">' + splittedWord[i] + '</div></div>';
            }

            return markup;
        }

        PACLexique.prototype.playWord = function (e) {

            var categoryIndex = $(e.currentTarget).data("category-index");
            var itemIndex = $(e.currentTarget).data("item-index");
            var translationIndex = $(e.currentTarget).data("translation-index");
            var itemData = this.data.categories[categoryIndex].items[itemIndex];
            var audioFilePath = itemData.translations_items[this.currentLanguage][translationIndex].audio;
            var $currentWords = $(e.currentTarget);
            var totalLetterCount = $currentWords.find(".progress").text().length;

            if (this.audio.isPlaying(audioFilePath)) {
                console.log("Already playing.");
                return;
            }

            // Stop current playing
            this.stopWord();

            // Play audio
            // this.audio.play("audio/lorem_ipsum.mp3", true, false, $.proxy(function (audio) {
            this.audio.play(audioFilePath, true, false, $.proxy(function (audio) {

                var durationTarget = Math.max(0.5, audio.duration - 0.5);
                // console.log("duration", audio.duration)

                this.playWordTimeline = new TimelineMax();
                $($currentWords).find(".part").each($.proxy(function (i, n) {
                    var partLetterCount = $(n).find(".progress").text().length;
                    var delay = (i == 0) ? 0.4 : "+=0.0";
                    this.playWordTimeline.fromTo($(n).find(".progress"), (partLetterCount / totalLetterCount * durationTarget), {
                        width: 0,
                    }, {
                        width: $(n).find(".background").width(),
                        ease: Linear.easeNone,
                    }, delay);
                }, this));

            }, this));
        }

        PACLexique.prototype.stopWord = function () {
            if (this.playWordTimeline != false) {
                this.playWordTimeline.kill();
                this.playWordTimeline = false;
            }

            $("#main-slider .language-word .progress").css("width", 0);

            // Stop audio
            this.audio.stop();
        }

        PACLexique.prototype.closeWord = function () {
            this.stopWord();

            if (this.currentScreen == 3) {
                var tl = new TimelineMax();
                tl.to($("#main-slider, #language-bar"), 0.45, {
                    opacity: 0,
                    scale: 0.9,
                    ease: this.defaultEasing,
                }, 0);

                // Fade out $category-clone
                if ($("#grid-sticky-category").hasClass("is-sticky") == false) {
                    tl.to("#category-clone", 0.45, {
                        autoAlpha: 0,
                        ease: this.defaultEasing,
                    }, 0);
                }

                tl.add($.proxy(function () {
                    this.goToScreen(2, $.proxy(function () {
                        // Hard hide of $category-clone
                        TweenMax.set("#category-clone", {
                            autoAlpha: 0,
                        });
                    }, this));
                }, this), "+=0.2", [], this);
            }
        }

        PACLexique.prototype.reset = function (screenId) {

            // Super
            if (BaseGamePAC.prototype.reset.call(this, screenId) == false) {
                return false;
            }
            //
            // this.isAnimatingDrag = false;
            // this.selectLanguageBarItem("algonquin");
            //
            // this.currentCategoryIndex = -1;
            // this.selectCategory(0);

            if (this.redirectTimeout != false) {
                clearTimeout(this.redirectTimeout);
                this.redirectTimeout = false;
            }

        }

        function widestPart(languageWord) {
            var widestPartWidth = 0;
            $(".part", languageWord).each($.proxy(function (i, part) {
                widestPartWidth = Math.max(widestPartWidth, $(part).width());
            }, this));
            return widestPartWidth;
        }


        // Expose PACLexique
        window.PACLexique = PACLexique;
    }
)
(jQuery, Promise);
